const SignalEvent = {
  ResourceProcessed: 'ResourceProcessed',
  ResourceError: 'ResourceError',
  StudioCardGenerationError: 'StudioCardGenerationError',
  CategoriesImportComplete: 'CategoriesImportComplete',
  CategoriesImportFailed: 'CategoriesImportFailed',
  StoryZipDownloadComplete: 'StoryZipDownloadComplete',
  StoryThumbnailProcessed: 'StoryThumbnailProcessed',
  StoryThumbnailError: 'StoryThumbnailError',
  StoryIconProcessed: 'StoryIconProcessed',
  StoryIconError: 'StoryIconError',
  AnalyticsExportComplete: 'AnalyticsExportComplete',
  ClipAnalyticsExportComplete: 'ClipAnalyticsExportComplete',
  TriviaQuizComplete: 'TriviaQuizComplete',
  RecipeRunComplete: 'RecipeRunComplete',
  RecipeRunFailed: 'RecipeRunFailed',
  ContentBankAssetGenerationSuccess: 'ContentBankAssetGenerationSuccess',
  ContentBankAssetGenerationError: 'ContentBankAssetGenerationError',
  RecipeStepUpdated: 'RecipeStepUpdated',
  ClipTranscriptionSuccess: 'ClipTranscriptionSuccess',
  ClipTranscriptionError: 'ClipTranscriptionError',
  ImageTitle: 'ImageTitle',
  FollowableThumbnail: 'FollowableThumbnail',
  ProfileBackgroundImage: 'ProfileBackgroundImage',
  StoryPageCaptionTranscriptionSuccess: 'PageTranscriptionSuccess',
  StoryPageCaptionTranscriptionError: 'PageTranscriptionError',
};

export default SignalEvent;
